'use client';
import { useEffect, useState } from 'react';

type ProductInfo = {
  Brand: string;
  Product: string;
  Variant: string;
  UPID: string;
  SKU: string;
};
/**
 * Get the current product information from the page's JSON-LD
 * Only works client side on the PDP
 * @returns the current product, or null if not found
 */
export const useCurrentProduct = (): ProductInfo | null => {
  const [productInfo, setProductInfo] = useState<ProductInfo | null>(null);

  useEffect(() => {
    const productJsonLd = document.getElementById('product-json-ld');
    try {
      if (productJsonLd != null) {
        const productJson = JSON.parse(productJsonLd.textContent ?? '');
        setProductInfo({
          Brand: productJson['brand']?.['name'],
          Product: productJson['name'],
          Variant: productJson['color'],
          UPID: productJson['productID'],
          SKU: productJson['sku'],
        });
      }
    } catch (e) {
      setProductInfo(null);
    }
  }, []);
  return productInfo;
};
